import React, {useState} from 'react';
import {connect, DispatchProp} from "react-redux";
import {RootState} from "../../../../reducers";
import {PlaceApi} from "../../../services/Api/types";
import {ReactComponent as MarkerSVG} from "../../../../images/icons/marker.svg";
import {ReactComponent as MenuSVG} from "../../../../images/icons/menu.svg";
import {ReactComponent as PhoneSVG} from "../../../../images/icons/phone.svg";
import {ReactComponent as ArrowRightSVG} from "../../../../images/icons/arrow-right.svg";
import StorageStore from "../../../services/Common/Storage/storageStore";
import {FormatAddressString} from "go-core/components/Formatters/FormatAddress";
import {Link} from "react-router-dom";
import OpenStoreModal from "./OpenStoreModal";
import {useTranslation} from "react-i18next";
import {FormattedPhoneNumber} from "../../../components/Common/FormattedPhoneNumber";

interface OwnProps {
    place: PlaceApi
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;
const PlaceItemMultistoreComponent = (props: Props) => {
    const [requiredLocationModal, setRequiredLocationModal] = useState<PlaceApi | undefined>(undefined);
    const {t} = useTranslation();
    let link = props.place.domain.replace(`${StorageStore.storeDomain}/`, "/");

    if (!link.startsWith('/')) {
        link = '/' + link;
    }

    const renderDistance = (distance: number) => {
        const newDistance = Math.round((distance + Number.EPSILON) * 100) / 100
        return `${newDistance} km`;
    }

    const renderTypes = (place: PlaceApi) => {
        const types = place.types;
        if (types === undefined) return null;
        let nameTypes = types.map(type => {
            if (type == 'DELIVERY') return `${t("enums.order.type.DELIVERY")} ${place.delivery?.delivery_price ? `: ${place.delivery.delivery_price}` : ""}`;
            if (type == 'PICK_UP') return t("enums.order.type.PICK_UP");
            if (type == 'DINE_IN') return t("enums.order.type.DINE_IN")
        })
        return (
            <ul className={"list-inline"}>
                {nameTypes.map(typeString => {
                    return (
                        <li key={typeString}>{typeString}</li>
                    )
                })}
            </ul>
        )
    }

    const openStore = (event: React.MouseEvent<HTMLAnchorElement | HTMLDivElement, MouseEvent>) => {
        event.preventDefault();
        setRequiredLocationModal(props.place)
    }

    const showAddressNotAvailableText = () => {
        return !props.place.in_delivery_zone && props.session.full_address;
    }

    return (
        <>
            {requiredLocationModal && (
                <OpenStoreModal storeUrl={link} openStore={openStore} place={requiredLocationModal}
                                onHide={() => setRequiredLocationModal(undefined)}/>
            )}
            <div className={"card-place"}>
                <div className={"card-place-wrapper"}>
                    <div className={"card-header"} onClick={openStore}>
                        <div className={"icon-square"}>
                            <MarkerSVG/>
                        </div>
                        <div className={"card-header-text"}>
                            <p>{props.place.name}</p>
                            <span>{FormatAddressString(props.place.address)}</span>
                        </div>
                    </div>
                    <div className={"card-body"} onClick={openStore}>
                        <ul className="icon-list">
                            {/*<li><ClockSVG/> Otwarte do 23:00</li>*/}
                            <li><MenuSVG/> {renderTypes(props.place)}</li>
                            {showAddressNotAvailableText() && (
                                <li className={"text-danger"}>
                                    <MarkerSVG/> {t("modules.multistore.field.your_address_is_not_available.title")}
                                </li>
                            )}
                        </ul>
                    </div>
                    <Link to={link} className={"btn btn-default me-1"} onClick={openStore}>
                        Menu
                    </Link>
                    {
                        props.place.distance !== undefined &&
                        <Link to={link} className={"btn btn-default me-1"} onClick={openStore}>
                            {renderDistance(props.place.distance)}
                        </Link>
                    }
                    {props.place.phone_number !== undefined && (
                        <a className={"btn btn-default phone"}
                           href={`tel:${props.place.phone_number}`}><PhoneSVG/><span><FormattedPhoneNumber
                            phoneNumber={props.place.phone_number}/></span></a>
                    )}
                </div>
                <Link className={"card-place-navigate"} to={link} onClick={openStore}
                      aria-label={`${t("modules.multistore.action.go_to_restaurant.title")} ${props.place.name}`}>
                    <ArrowRightSVG aria-hidden="true"/>
                </Link>
            </div>
        </>
    )
}

const mapStateToProps = (state: RootState) => ({
    session: state.session
})

const connector = connect(mapStateToProps);

export default connector(PlaceItemMultistoreComponent);